<template>
  <div>
    <div class="flex x-xx-x-deneme">
      <div v-if="!loginPage" :class="{ showMenu: mobileShow }">
        <div
          class="sidebar   print:hidden hidden md:flex"
          :class="{ 'w-60': menuNameShow, 'w-20': !menuNameShow }"
        >
          <div>
            <a href="/" class="block">
              <div class="flex justify-between items-center mr-4">
                <h2 class="logo p-1 px-2 m-0 text-xl flex flex-col">
                  <span class="text-xs"><span class="">VIQQA</span></span>

                
                  <template v-if="$root.cache.me.team_id">
                    <span  v-if="$root.cache.me.team_id > 1" class="text-xl">
                      {{ $root.cache.me.team }}</span> 

                  <span v-else class="text-xl">{{ $root.config.appName }}</span>

                  </template>

                  <span v-else class="text-xl">{{ $root.config.appName }}</span>


                </h2>
                <div>
                  <vk-spinner v-if="loading" ratio="0.5"></vk-spinner>
                </div>
              </div>
            </a>
            <h5 class="text-xs px-3 text-gray-600 m-0 p-0 mb-1">Menü</h5>
            <div
              class="sidebar-menu text-sm"
              v-for="(table, index) in $root.cache.tables"
              v-if="table.location == 1"
              :key="table.id"
            >
              <template v-if="table.url">
                <router-link :to="{ name: table.url, params: { index } }">
                  <div
                    :class="{
                      'active-url font-medium': $route.params.index == index,
                    }"
                    class="url flex w-full items-center justify-start"
                  >
                    <vk-icon
                      ratio="1"
                      class="opacity-40"
                      :icon="table.icon"
                    ></vk-icon>
                    <div class=" flex w-full  justify-between   items-center">
                      <div v-if="menuNameShow">{{ table.name }}</div>
                      <div
                        class="text-gray-100 hover:text-gray-600"
                        v-if="$route.params.index == index"
                        @click="reload()"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="w-4 h-4 cursor-pointer"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M4 20v-7h7l-3.217 3.22A5.917 5.917 0 0 0 12 18a6 6 0 0 0 5.648-4h.018c.114-.325.201-.66.259-1h2.012A8 8 0 0 1 12 20h-.01a7.941 7.941 0 0 1-5.653-2.34L4 20Zm2.074-9H4.062a8 8 0 0 1 7.933-7H12a7.94 7.94 0 0 1 5.654 2.34L20 4v7h-7l3.222-3.22A5.916 5.916 0 0 0 12 6a6 6 0 0 0-5.648 4h-.018c-.115.325-.202.66-.259 1h-.001Z"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </router-link>
              </template>
              <template v-else>
                <router-link
                  :to="{ name: 'list', params: { index, table: table.table } }"
                >
                  <div
                    :class="{
                      'active-url font-medium':
                        $route.params.table == table.table,
                    }"
                    class="url"
                  >
                    <vk-icon
                      ratio="1"
                      class="opacity-40"
                      :icon="table.icon"
                    ></vk-icon>
                    <div class=" flex w-full  justify-between   items-center">
                      <span v-if="menuNameShow"> {{ table.name }} </span>
                      <span
                        class="text-gray-100 hover:text-gray-600"
                        v-if="$route.params.table == table.table"
                        @click="reload()"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="w-4 h-4 cursor-pointer"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M4 20v-7h7l-3.217 3.22A5.917 5.917 0 0 0 12 18a6 6 0 0 0 5.648-4h.018c.114-.325.201-.66.259-1h2.012A8 8 0 0 1 12 20h-.01a7.941 7.941 0 0 1-5.653-2.34L4 20Zm2.074-9H4.062a8 8 0 0 1 7.933-7H12a7.94 7.94 0 0 1 5.654 2.34L20 4v7h-7l3.222-3.22A5.916 5.916 0 0 0 12 6a6 6 0 0 0-5.648 4h-.018c-.115.325-.202.66-.259 1h-.001Z"
                          />
                        </svg>
                      </span>
                    </div>
                  </div>
                </router-link>
              </template>
            </div>
            <h5 class="text-xs px-3 text-gray-600 m-0 p-0 mb-1">Raporlar</h5>

            <!-- Kategori Menüleri -->
            <div
              v-if="reportCategories && reportCategories.length > 0"
              class="sidebar-menu text-sm"
              v-for="(category, index) in reportCategories"
              :key="category.id"
            >
              <a :href="'/reports?category_id=' + category.id">
                <div class="url flex w-full items-center justify-start">
                  <vk-icon
                    ratio="1"
                    class="opacity-40"
                    :icon="category.icon || 'list'"
                  ></vk-icon>
                  <div class=" flex w-full  justify-between   items-center">
                    <div v-if="menuNameShow">{{ category.name }}</div>
                  </div>
                </div>
              </a>
            </div>

            <!-- Mevcut Report Menüleri -->
            <div
              class="sidebar-menu text-sm"
              v-for="(table, index) in $root.cache.tables"
              v-if="table.location == 4"
              :key="table.id"
            >
              <template v-if="table.url">
                <a :href="'/' + table.url">
                  <div class="url flex w-full items-center justify-start">
                    <vk-icon
                      ratio="1"
                      class="opacity-40"
                      :icon="table.icon"
                    ></vk-icon>
                    <div class=" flex w-full  justify-between   items-center">
                      <div v-if="menuNameShow">{{ table.name }}</div>
                    </div>
                  </div>
                </a>
              </template>
              <template v-else>
                <a :href="'/list/' + table.table">
                  <div class="url">
                    <vk-icon
                      ratio="1"
                      class="opacity-40"
                      :icon="table.icon"
                    ></vk-icon>
                    <div class=" flex w-full  justify-between   items-center">
                      <span v-if="menuNameShow"> {{ table.name }} </span>
                    </div>
                  </div>
                </a>
              </template>
            </div>
          </div>
          <div>
            <div class=" text-gray-600">
              <h5
                class="text-xs flex items-center space-x-2 text-gray-600 cursor-pointer m-0 p-2 mb-1 hover:bg-gray-100 rounded"
                @click="$emit('openFavoritesDrawer')"
              >
                <svg
                  version="1.1"
                  meta="vk-icons-heart"
                  class="w-4 h-4"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill="none"
                    stroke="#000"
                    stroke-width="1"
                    d="M10,4 C10,4 8.1,2 5.74,2 C3.38,2 1,3.55 1,6.73 C1,8.84 2.67,10.44 2.67,10.44 L10,18 L17.33,10.44 C17.33,10.44 19,8.84 19,6.73 C19,3.55 16.62,2 14.26,2 C11.9,2 10,4 10,4 L10,4 Z"
                  ></path>
                </svg>
                <span v-if="menuNameShow">Favoriler</span>
                <span v-if="favorites.length > 0" class="bg-gray-200 text-gray-600 px-1.5 py-0.5 rounded-full text-xs ml-auto">
                  {{ favorites.length }}
                </span>
              </h5>
            </div>
            <div class=" text-gray-600">
              <h5
                class="text-xs flex items-center space-x-2 text-gray-600 cursor-pointer m-0 p-2 mb-1"
                @click="sidebarNoteToggle()"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-4 h-4"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M5 18.77v-1h1.615V9.845q0-1.96 1.24-3.447Q9.097 4.912 11 4.546V3h2v1.546q1.904.366 3.144 1.853q1.24 1.488 1.24 3.447v7.923H19v1H5Zm7-7.155Zm0 9.77q-.671 0-1.143-.473q-.472-.472-.472-1.143h3.23q0 .671-.472 1.144q-.472.472-1.143.472Zm-4.385-3.616h8.77V9.846q0-1.823-1.281-3.104q-1.28-1.28-3.104-1.28t-3.104 1.28q-1.28 1.281-1.28 3.104v7.923ZM3.231 9.827q0-1.923.766-3.578q.766-1.655 2.084-2.857l.675.735q-1.173 1.061-1.85 2.525q-.675 1.463-.675 3.175h-1Zm16.538 0q0-1.712-.676-3.185t-1.849-2.534l.675-.716q1.318 1.202 2.084 2.857q.766 1.655.766 3.578h-1Z"
                  />
                </svg>
                <span v-if="menuNameShow">Yaklaşan 10 Hatırlatma</span>
              </h5>
              <div v-if="sidebarNoteShow == true">
                <div v-if="sidebarNotes.length > 0">
                  <a
                    :href="'/leadDetail/' + sidebarNote.lead_id"
                    v-for="sidebarNote in sidebarNotes"
                    :key="sidebarNote.lead_id"
                    class="border-t  text-xs text-gray-600 block hover:bg-white p-1 px-2"
                  >
                    <p class="p-0 text-gray-500 m-0">{{ sidebarNote.body }}</p>
                    <div>
                      <span class=" text-gray-600">{{
                        sidebarNote.lead_name
                      }}</span>
                    </div>
                  </a>
                </div>
                <h5
                  v-else
                  class="text-xs bg-tile-50 text-tile-600 p-2 flex space-x-2 mb-1"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="currentColor"
                      d="M5 18.77v-1h1.615V9.845q0-1.96 1.24-3.447Q9.097 4.912 11 4.546V3h2v1.546q1.904.366 3.144 1.853q1.24 1.488 1.24 3.447v7.923H19v1H5Zm7-7.155Zm-.003 9.77q-.668 0-1.14-.475q-.472-.474-.472-1.14h3.23q0 .67-.475 1.142q-.476.473-1.143.473Zm-4.382-3.616h8.77V9.846q0-1.823-1.281-3.104q-1.28-1.28-3.104-1.28t-3.104 1.28q-1.28 1.281-1.28 3.104v7.923Zm3.885-4.961h1V8h-1v4.808Zm.5 2.807q.262 0 .438-.177q.177-.176.177-.438t-.177-.438q-.176-.177-.438-.177t-.438.177q-.177.176-.177.438t.177.438q.176.177.438.177Z"
                    />
                  </svg>
                  <span>Yaklaşan hatırlatma yok</span>
                </h5>
              </div>
            </div>
            <div>
              <div
                class="
              cursor-pointer
              p-2
              border-t
              flex
              justify-between
              items-center
            "
              >
                <div class="" @click="sidebarProfile = !sidebarProfile">
                  <span class="text-gray-600  font-light text-xs"
                    >Hoşgeldiniz,</span
                  >
                  <br />
                  <span class="text-gray-800 font-bold">{{ userName }}</span>
                </div>
                <div class="flex items-center justify-center">
                  <div
                    @click="openNotifications()"
                    class="flex w-10 items-center justify-center"
                  >
                    <vk-icon icon="bell" class="opacity-40" />
                    <div
                      v-if="notificationCount > 0"
                      class="bg-red-500 absolute ml-3 -mt-3 text-white rounded-full px-1 text-xs"
                    >
                      {{ notificationCount }}
                    </div>
                  </div>
                  <router-link
                    to="/logout"
                    class="flex w-10 items-center justify-center"
                  >
                    <vk-icon icon="sign-out" class="opacity-40" />
                  </router-link>
                </div>
              </div>
              <div class="sidebar-menu" v-if="sidebarProfile">
                <router-link class="url" to="/profile">
                  <vk-icon class="opacity-40" ratio="1" icon="user" />
                  <span class="text-sm">Profil</span>
                </router-link>
                <router-link class="url" to="/admin">
                  <vk-icon class="opacity-40" ratio="1" icon="unlock" />
                  <span class="text-sm">Yönetim Paneli</span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class=" w-full min-h-screen mb-20"
        :class="{ ' md:ml-60 ': !loginPage }"
      >
        <router-view
          class="m-2 md:mx-0 md:my-2  bg-white border shadow rounded-lg"
        />
      </div>
    </div>

    <vk-offcanvas-content class="shadow notification-list">
      <vk-offcanvas flipped :show.sync="notificationList">
        <h3 class="font-medium text-lg">
          Bildirimler ({{ notificationCount }})
        </h3>
        <vk-offcanvas-close
          @click="notificationList = false"
        ></vk-offcanvas-close>
        <NotificationsVue :notifications="notifications" />
      </vk-offcanvas>
    </vk-offcanvas-content>
  </div>
</template>

<script>
import AuthService from "./services/auth";
import EventBus from "./components/Ui/EventBus";

import NotificationsVue from "./components/Ui/Notifications.vue";
import notificationStore from "./services/notificationStore";
import http from "./services/http";
export default {
  components: {
    NotificationsVue,
  },
  props: [
    "favorites",
    "userName",
    "userID",
    "notifications",
    "sidebarNotes",
    "notificationCount",
  ],
  data() {
    return {
      messages: [],
      mobileShow: false,
      menuNameShow: true,
      messagesType: "primary",
      loginPage: true,
      loading: true,
      sidebarProfile: false,
      themeBackground: null,
      searchValue: null,
      routeSelected: this.$route.params.index,
      searchTable: "leads",
      favoriteShow: false,
      sidebarNoteShow: false,
      show: false,
      isOpen: false,
      notificationList: false,
      results: [],
      search: "",
      themeStyle: 1,
      theme: "head_navbar",
      themeDark: false,
      themeMenuShow: 250,
      isLoading: false,
      arrowCounter: -1,
      reportCategories: [],
    };
  },
  created() {
    this.loading = false;
    this.checkLoginPage();
    this.getReportCategories();
    if (localStorage.theme) {
      this.theme = localStorage.theme;
    }
  },
  watch: {
    $route(to) {
      if (to.meta.location == 1) {
        this.routeSelected = to.params.index;
      }
    },
    searchTable() {
      this.searchSubmit();
    },
    searchValue(data) {
      if (data == "") {
        setTimeout(() => {
          this.show = false;
        }, 5000);
      }
    },
  },
  methods: {
    openNotifications() {
      this.notificationList = true;
      // Panel açıldığında okunmamış rozeti sıfırlanır.
      notificationStore.markAllSeen();
    },
    reload() {
      EventBus.$emit("reflesh", true);
    },

    getReportCategories() {
      http.getReportCategories().then((resp) => {
        if (resp.data.success && resp.data.categories) {
          this.reportCategories = resp.data.categories;
        }
      }).catch(() => {
        // API hatası durumunda boş bırak
        this.reportCategories = [];
      });
    },
    getFavorites() {
      http.getFavorites().then((resp) => {
        this.favorites = resp.data;
      });
    },
    removeFavorite(id) {
      http.removeFavorite(id).then(() => {
        this.getFavorites();
      });
    },

    sidebarNoteToggle() {
      this.sidebarNoteShow = !this.sidebarNoteShow;
      localStorage.sidebarNoteShow = this.sidebarNoteShow;
    },
    favoriteToggle() {
      this.favoriteShow = !this.favoriteShow;
      localStorage.favoriteShow = this.favoriteShow;
    },
    logout() {
      AuthService.logout().then(() => {
        this.$router.push("logout");
      });
    },
    checkLoginPage() {
      if (this.$route.meta.requiresAuth == false) {
        this.loginPage = true;
      } else {
        this.loginPage = false;
      }
    },
    onChange() {
      // Let's warn the parent that a change was made
      this.$emit("input", this.search);
      // Let's  our flat array
      this.filterResults();
      this.isOpen = true;
    },
    setResult(result) {
      this.search = result;
      this.isOpen = false;
    },
    handleClickOutside(evt) {
      if (!this.$el.contains(evt.target)) {
        this.isOpen = false;
        this.arrowCounter = -1;
      }
    },
    onArrowDown() {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },
    onEnter() {
      this.searchValue = this.results[this.arrowCounter];
      this.isOpen = false;
      this.arrowCounter = -1;
    },
  },
  destroyed() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.sidebar {
  @apply text-gray-700 h-screen flex-col justify-between fixed z-20;
}

.sidebar a {
  @apply text-gray-800;
}

.sidebar .url-flex {
  @apply space-x-2;
}

.sidebar-menu .url {
  @apply flex justify-start border-transparent items-center space-x-2 p-1 px-2;
}

.sidebar-menu .url:hover,
.active-url {
  @apply bg-pampas-600 bg-opacity-30 text-gray-700 border-gray-700;
}
a .sidebar ul {
  margin: 0px;
  padding: 0px;
}

.favorite-list-item:hover .favorite-remove {
  display: block;
}

.favorite-remove {
  display: none;
}

.favorite-remove:hover {
  @apply text-red-400;
}

.mobile-menu a {
  @apply text-gray-700;
}
</style>
